import { Input,  Directive } from '@angular/core';
import { BaseUIComponent } from './base-ui-component';

@Directive()
export class BaseUIEditableComponent extends BaseUIComponent {

    @Input() TabIndexVal: string;

    set TabIndex(arg) {
        this.TabIndexVal = arg;
        this.setTabIndexValue();
    }

    setTabIndexValue() {

    }

    set ClassName(arg) {
        this.className = arg;
        if (this.domEl) {
            this.domEl.nativeElement.className = this.className;
        } else {
            this.appendAClass();
        }
    }

    get ClassName() {
        return this.className;
    }

    set Disabled(arg) {
        if (arg != null && typeof arg != 'undefined') {
            this.disabled = arg.toString();
        }
    }

    appendAClass(className: string = '') {

    }

}


